
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StatCard',
  data() {
    return {
    };
  },
});
